// src/i18n/es/activityMonitorMetrics.ts

export const activityMonitorMetrics = {
  metrics: {
    eventsPerMinute: 'Eventos por minuto - Tasa de actividad en tiempo real',
    avgSessionTime: 'Duración promedio de sesión en minutos',
    eventsMin: 'Eventos/min',
    avgTime: 'Tiempo Prom',
  },
  active: 'Activo',
  completed: 'Completado',
  errors: 'Errores',
};

export default activityMonitorMetrics;
